// import { useState, useCallback, useEffect } from 'react';
// import { format } from 'date-fns';
// import Cookies from 'js-cookie';

// const usePaginatedData = ({
//   activeTab,
//   searchQuery,
//   startDate,
//   endDate,
//   endpoints,
//   transformFunctions,
//   baseUrl = process.env.REACT_APP_BASE_URL,
//   initialPageSize = 10
// }) => {
//   const [data, setData] = useState([]);
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 0,
//     totalItems: 0,
//     itemsPerPage: initialPageSize,
//     hasNextPage: false,
//     hasPreviousPage: false,
//     startIndex: 0,
//     endIndex: 0
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Utility functions
//   const capitalize = (string) => {
//     if (!string) return "";
//     return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
//   };

//   const formatNumber = (num) => {
//     const parsedNum = Number(num);
//     if (isNaN(parsedNum) || num === undefined || num === null) {
//       return "0";
//     }
//     return parsedNum.toLocaleString("en-US");
//   };

//   // const formatDateForAPI = (date) => {
//   //   try {
//   //     let dateObj;
//   //     if (typeof date === 'string') {
//   //       dateObj = new Date(date);
//   //       if (isNaN(dateObj.getTime())) {
//   //         console.warn('Invalid date string:', date);
//   //         return null;
//   //       }
//   //     } else {
//   //       dateObj = new Date(date);
//   //       if (isNaN(dateObj.getTime())) {
//   //         console.warn('Invalid date object:', date);
//   //         return null;
//   //       }
//   //     }

//   //     // Format as DD-MM-YYYY
//   //     const day = dateObj.getDate().toString().padStart(2, '0');
//   //     const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
//   //     const year = dateObj.getFullYear();
      
//   //     return `${day}-${month}-${year}`;
//   //   } catch (error) {
//   //     console.warn('Error formatting date:', date, error);
//   //     return null;
//   //   }
//   // };

//   // Add date filters if present
// //       if (startDate && endDate) {
//         const formatDateForAPI = (date) => {
//           try {
//             if (typeof date === 'string') {
//               // If it's already a string, try to parse it first
//               const parsedDate = new Date(date);
//               if (isNaN(parsedDate.getTime())) {
//                 console.warn('Invalid date string:', date);
//                 return null;
//               }
//               return parsedDate.toISOString().split('T')[0];
//             }
//             // If it's a Date object
//             const dateObj = new Date(date);
//             if (isNaN(dateObj.getTime())) {
//               console.warn('Invalid date object:', date);
//               return null;
//             }
//             return dateObj.toISOString().split('T')[0];
//           } catch (error) {
//             console.warn('Error formatting date:', date, error);
//             return null;
//           }
//         };

//   // Default transform functions if not provided
//   const defaultTransformFunctions = {
//     'scanned-records': (data) => {
//       return data.map((item) => ({
//         id: item.id,
//         province: item.site?.site.province,
//         district: item.site?.site.district,
//         sector: item.site?.site.sector || "-",
//         bookName: item.book?.name,
//         bookNumber: item.bookNumber || "-",
//         bookType: capitalize(item.book?.bookType) || "-",
//         count: formatNumber(item.count) || 0,
//         scannerOperator: item.assignedTo
//           ? item.assignedToUser.name
//           : item.scannerOperator?.name || "-",
//         status: item.status,
//         recordedAt: format(new Date(item.createdAt), "dd-MM-yyyy"),
//         createdAt: item.createdAt,
//         addedAt: format(new Date(item.scanDate), "dd-MM-yyyy HH:mm:ss"),
//       }));
//     },
//     'yellow-forms': (data) => {
//       return data.map((item) => ({
//         id: item.id,
//         province: item.site?.site.province,
//         district: item.site?.site.district,
//         sector: item.site?.site.sector || "-",
//         yellowFormCount: formatNumber(item.yellowFormCount) || 0,
//         scannerOperator: item.assignedTo
//           ? item.assignedToUser.name
//           : item.scannerOperator?.name || "-",
//         status: item.status,
//         recordedAt: format(new Date(item.createdAt), "dd-MM-yyyy"),
//         createdAt: item.createdAt,
//         addedAt: format(new Date(item.addedAt), "dd-MM-yyyy HH:mm:ss"),
//       }));
//     },
//     'indexed-records': (data) => {
//       return data.map((item) => ({
//         id: item.id,
//         province: item.site?.site?.province || "-",
//         district: item.site?.site?.district || "-",
//         sector: item.site?.site?.sector || "-",
//         bookName: item.book?.name || "-",
//         bookType: capitalize(item.book?.bookType) || "-",
//         count: item.count || 0,
//         clerkName: item.assignedToClerk?.name || item.clerk?.name || "-",
//         status: item.status || "PENDING",
//         recordedAt: item.createdAt
//           ? format(new Date(item.createdAt), "dd-MM-yyyy")
//           : "-",
//         createdAt: item.createdAt || null,
//       }));
//     }
//   };

//   const fetchData = useCallback(async (page = 1, limit = 10) => {
//     if (!activeTab || !endpoints[activeTab]) return;
    
//     setLoading(true);
//     setError(null);
//     const token = Cookies.get("token");

//     try {
//       // Build query parameters
//       const params = new URLSearchParams({
//         page: page.toString(),
//         limit: limit.toString(),
//       });

//       // Add search query if present
//       if (searchQuery?.trim()) {
//         params.append('search', searchQuery.trim());
//       }

//       // Add date filters if present
//       if (startDate && endDate) {
//         const formattedStartDate = formatDateForAPI(startDate);
//         const formattedEndDate = formatDateForAPI(endDate);

//         if (formattedStartDate && formattedEndDate) {
//           params.append('startDate', formattedStartDate);
//           params.append('endDate', formattedEndDate);
//         }
//       }

//       const endpoint = endpoints[activeTab];
//       const response = await fetch(
//         `${baseUrl}${endpoint}?${params.toString()}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`Failed to fetch ${activeTab}`);
//       }

//       const result = await response.json();
      
//       // Transform the data based on activeTab
//       const transformFunction = transformFunctions?.[activeTab] || defaultTransformFunctions[activeTab];
//       const transformedData = transformFunction 
//         ? transformFunction(result.data || result || [])
//         : result.data || result || [];

//       setData(transformedData);
      
//       // Set pagination info
//       if (result.pagination) {
//         setPagination(result.pagination);
//       } else {
//         // Fallback for when backend doesn't return pagination metadata
//         setPagination({
//           currentPage: page,
//           totalPages: Math.ceil(transformedData.length / limit),
//           totalItems: transformedData.length,
//           itemsPerPage: limit,
//           hasNextPage: page < Math.ceil(transformedData.length / limit),
//           hasPreviousPage: page > 1,
//           startIndex: (page - 1) * limit + 1,
//           endIndex: Math.min(page * limit, transformedData.length)
//         });
//       }
      
//     } catch (err) {
//       setError(err.message);
//       setData([]);
//       setPagination({
//         currentPage: 1,
//         totalPages: 0,
//         totalItems: 0,
//         itemsPerPage: limit,
//         hasNextPage: false,
//         hasPreviousPage: false,
//         startIndex: 0,
//         endIndex: 0
//       });
//     } finally {
//       setLoading(false);
//     }
//   }, [activeTab, searchQuery, startDate, endDate, baseUrl, endpoints, transformFunctions]);

//   const goToPage = useCallback((page) => {
//     if (page >= 1 && page <= pagination.totalPages) {
//       fetchData(page, pagination.itemsPerPage);
//     }
//   }, [fetchData, pagination.totalPages, pagination.itemsPerPage]);

//   const changePageSize = useCallback((newLimit) => {
//     fetchData(1, newLimit);
//   }, [fetchData]);

//   const refresh = useCallback(() => {
//     fetchData(pagination.currentPage, pagination.itemsPerPage);
//   }, [fetchData, pagination.currentPage, pagination.itemsPerPage]);

//   // Fetch data when dependencies change
//   useEffect(() => {
//     fetchData(1, pagination.itemsPerPage); // Reset to first page when filters change
//   }, [activeTab, searchQuery, startDate, endDate, fetchData, pagination.itemsPerPage]);

//   return {
//     data,
//     pagination,
//     loading,
//     error,
//     goToPage,
//     changePageSize,
//     refresh,
//     // Export utility functions for external use
//     utils: {
//       capitalize,
//       formatNumber,
//       formatDateForAPI
//     }
//   };
// };

// export default usePaginatedData;




import { useState, useCallback, useEffect } from 'react';
import { format } from 'date-fns';
import Cookies from 'js-cookie';

const usePaginatedData = ({
  activeTab,
  searchQuery,
  districtSearchQuery,
  sectorSearchQuery,
  operatorSearchQuery,
  bookTypeFilter,
  startDate,
  endDate,
  endpoints,
  transformFunctions,
  baseUrl = process.env.REACT_APP_BASE_URL,
  initialPageSize = 10
}) => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: initialPageSize,
    hasNextPage: false,
    hasPreviousPage: false,
    startIndex: 0,
    endIndex: 0
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Utility functions
  const capitalize = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const formatNumber = (num) => {
    const parsedNum = Number(num);
    if (isNaN(parsedNum) || num === undefined || num === null) {
      return "0";
    }
    return parsedNum.toLocaleString("en-US");
  };

  const formatDateForAPI = (date) => {
          try {
            if (typeof date === 'string') {
              // If it's already a string, try to parse it first
              const parsedDate = new Date(date);
              if (isNaN(parsedDate.getTime())) {
                console.warn('Invalid date string:', date);
                return null;
              }
              return parsedDate.toISOString().split('T')[0];
            }
            // If it's a Date object
            const dateObj = new Date(date);
            if (isNaN(dateObj.getTime())) {
              console.warn('Invalid date object:', date);
              return null;
            }
            return dateObj.toISOString().split('T')[0];
          } catch (error) {
            console.warn('Error formatting date:', date, error);
            return null;
          }
        };


  // Default transform functions if not provided
  const defaultTransformFunctions = {
    'scanned-records': (data) => {
      return data.map((item) => ({
        id: item.id,
        province: item.site?.site.province,
        district: item.site?.site.district,
        sector: item.site?.site.sector || "-",
        bookId: item.bookId,
        bookName: item.book?.name,
        bookNumber: item.bookNumber || "-",
        bookType: capitalize(item.book?.bookType) || "-",
        count: formatNumber(item.count) || 0,
        scannerOperator: item.assignedTo
          ? item.assignedToUser.name
          : item.scannerOperator?.name || "-",
        status: item.status,
        recordedAt: format(new Date(item.createdAt), "dd-MM-yyyy"),
        createdAt: item.createdAt,
        addedAt: format(new Date(item.scanDate), "dd-MM-yyyy HH:mm:ss"),
        scanDate: item.scanDate,
      }));
    },
    'yellow-forms': (data) => {
      return data.map((item) => ({
        id: item.id,
        province: item.site?.site.province,
        district: item.site?.site.district,
        sector: item.site?.site.sector || "-",
        yellowFormCount: formatNumber(item.yellowFormCount) || 0,
        scannerOperator: item.assignedTo
          ? item.assignedToUser.name
          : item.scannerOperator?.name || "-",
        status: item.status,
        recordedAt: format(new Date(item.createdAt), "dd-MM-yyyy"),
        createdAt: item.createdAt,
        addedAt: format(new Date(item.addedAt), "dd-MM-yyyy HH:mm:ss"),
      }));
    },
    'indexed-records': (data) => {
      return data.map((item) => ({
        id: item.id,
        province: item.site?.site?.province || "-",
        district: item.site?.site?.district || "-",
        sector: item.site?.site?.sector || "-",
        bookName: item.book?.name || "-",
        bookType: capitalize(item.book?.bookType) || "-",
        count: item.count || 0,
        clerkName: item.assignedToClerk?.name || item.clerk?.name || "-",
        status: item.status || "PENDING",
        recordedAt: item.createdAt
          ? format(new Date(item.createdAt), "dd-MM-yyyy")
          : "-",
        createdAt: item.createdAt || null,
      }));
    }
  };

  const fetchData = useCallback(async (page = 1, limit = 10) => {
    if (!activeTab || !endpoints[activeTab]) return;
    
    setLoading(true);
    setError(null);
    const token = Cookies.get("token");

    try {
      // Build query parameters
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      // Add search query if present
      if (searchQuery?.trim()) {
        params.append('search', searchQuery.trim());
      }

      // Independent district / sector / scanner operator / book category
      // filters - any combination of these can be applied at once.
      if (districtSearchQuery?.trim()) {
        params.append('districtSearch', districtSearchQuery.trim());
      }

      if (sectorSearchQuery?.trim()) {
        params.append('sectorSearch', sectorSearchQuery.trim());
      }

      if (operatorSearchQuery?.trim()) {
        params.append('operatorSearch', operatorSearchQuery.trim());
      }

      if (bookTypeFilter) {
        params.append('bookType', bookTypeFilter);
      }

      // Add date filters if present
      if (startDate && endDate) {
        const formattedStartDate = formatDateForAPI(startDate);
        const formattedEndDate = formatDateForAPI(endDate);

        if (formattedStartDate && formattedEndDate) {
          params.append('startDate', formattedStartDate);
          params.append('endDate', formattedEndDate);
        }
      }

      const endpoint = endpoints[activeTab];
      const response = await fetch(
        `${baseUrl}${endpoint}?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch ${activeTab}`);
      }

      const result = await response.json();
      
      // Transform the data based on activeTab
      const transformFunction = transformFunctions?.[activeTab] || defaultTransformFunctions[activeTab];
      const transformedData = transformFunction 
        ? transformFunction(result.data || result || [])
        : result.data || result || [];

      setData(transformedData);
      
      // Set pagination info
      if (result.pagination) {
        setPagination(result.pagination);
      } else {
        // Fallback for when backend doesn't return pagination metadata
        setPagination({
          currentPage: page,
          totalPages: Math.ceil(transformedData.length / limit),
          totalItems: transformedData.length,
          itemsPerPage: limit,
          hasNextPage: page < Math.ceil(transformedData.length / limit),
          hasPreviousPage: page > 1,
          startIndex: (page - 1) * limit + 1,
          endIndex: Math.min(page * limit, transformedData.length)
        });
      }
      
    } catch (err) {
      setError(err.message);
      setData([]);
      setPagination({
        currentPage: 1,
        totalPages: 0,
        totalItems: 0,
        itemsPerPage: limit,
        hasNextPage: false,
        hasPreviousPage: false,
        startIndex: 0,
        endIndex: 0
      });
    } finally {
      setLoading(false);
    }
  }, [activeTab, searchQuery, districtSearchQuery, sectorSearchQuery, operatorSearchQuery, bookTypeFilter, startDate, endDate, baseUrl]);

  const goToPage = useCallback((page) => {
    if (page >= 1 && page <= pagination.totalPages) {
      fetchData(page, pagination.itemsPerPage);
    }
  }, [fetchData, pagination.totalPages, pagination.itemsPerPage]);

  const changePageSize = useCallback((newLimit) => {
    fetchData(1, newLimit);
  }, [fetchData]);

  const refresh = useCallback(() => {
    fetchData(pagination.currentPage, pagination.itemsPerPage);
  }, [fetchData, pagination.currentPage, pagination.itemsPerPage]);

  // Fetch data when dependencies change
  useEffect(() => {
    if (activeTab && endpoints[activeTab]) {
      fetchData(1, pagination.itemsPerPage); // Reset to first page when filters change
    }
  }, [activeTab, searchQuery, districtSearchQuery, sectorSearchQuery, operatorSearchQuery, bookTypeFilter, startDate, endDate, fetchData]);

  return {
    data,
    pagination,
    loading,
    error,
    goToPage,
    changePageSize,
    refresh,
    // Export utility functions for external use
    utils: {
      capitalize,
      formatNumber,
      formatDateForAPI
    }
  };
};

export default usePaginatedData;